import { render } from "./EditEmployeeReport.vue?vue&type=template&id=59ed5dde&scoped=true"
import script from "./EditEmployeeReport.vue?vue&type=script&lang=js"
export * from "./EditEmployeeReport.vue?vue&type=script&lang=js"

import "./employee-report.scss?vue&type=style&index=0&id=59ed5dde&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ed5dde"]])

export default __exports__